import { Component, Input } from '@angular/core';
import { ContactDataForm } from '@bo-client/shared/models/contactDataDto';
import { ConnectionObjectFormV2 } from '@bo-client/shared/models/connectionObject';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent {
  @Input() isRequired = true;
  @Input() differsFromCurrentUser = false;
  @Input() disable: boolean = false;
  @Input()
  formGroup: ContactDataForm;
  @Input()
  connectionObjectData: ConnectionObjectFormV2['value'];

  copyConnectionObjectAddress() {
    if (!this.connectionObjectData) return;
    const { city, street, streetNo, zipCode } = this.formGroup.controls;
    city.setValue(this.connectionObjectData.city || null);
    zipCode.setValue(this.connectionObjectData.zipCode || null);
    street.setValue(this.connectionObjectData.street || null);
    streetNo.setValue(this.connectionObjectData.streetNo || null);
  }
}
